module.exports = __webpack_public_path__ + "static/media/upArrow.1dd1fcc6.svg";